import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { SharedService } from 'src/app/common/services/sharedService';
import { CommonConstants } from '../common/utilities/commonConstants';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';
import { GoogleAnalyticsService } from '../common/services/google_analytics.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { UiStyleToggleService } from './ui-style-toggle.service';

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss']
})
export class ToggleSwitchComponent implements OnInit {
  public theme: boolean;
  public Isdark: any;
  bflJourney: any;
  @Input() showToggle = false;
  constructor(private sharedService: SharedService, private renderer: Renderer2,
    private _sessionHandler: SessionHandlerService,
    private _routeContextProvider: RouteContextProvider,
    private themeService: UiStyleToggleService,
    private _googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit() {
    const currentTheme = localStorage.getItem('theme');
    this.Isdark = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.isDark);
    let url: any = window.location.pathname;
    url = url.split("/");
    this.bflJourney = url.includes(CommonConstants.QueryParamsKeys.marketplace);
    this.theme = !this.bflJourney ? true : false;
    if (currentTheme) {
      this.theme = currentTheme === 'dark' ? true : false;
    }
    if (this.Isdark === "1") {
      this.theme = true;
    } else if (this.Isdark === "0") { this.theme = false; }
    this.changeTheme();
  }

  changeTheme() {
    this.theme ? localStorage.setItem('theme', 'dark') : localStorage.setItem('theme', 'light');
    if (this.theme === true) {
      this.renderer.addClass(document.body, 'dark');
    } else {
      this.renderer.removeClass(document.body, 'dark');
    }
    this.sharedService.themeChange.next(true);
    this.themeService.toggle();
    this.setThemeVar();
  }

  // Google Analytic function to push data in DataLayer
  public googleAnalyticChange() {
    const mode = this.theme ? 'Dark Mode' : 'Bright Mode';
    this._googleAnalyticsService.pushToDataLayer({
      'event': 'mode_change_click',
      'pageType': 'Get Quote Page',
      'mode': mode,
      'productId': 'HGI',
      'productName': 'Health Insurance',
      'applicationId': this._sessionHandler.GetSession(CommonConstants.CookieKeys.applicationId)
    });
  }


  setThemeVar() {
    this.theme = this.themeService.isDarkThemeSelected() ? true : false;
  }

}
